import { PageAnchor } from 'src/app/AppAuth/PageAnchor'
import React from 'react'
import { CheckBoxInput } from 'src/components/Reusable/Inputs/CheckBox'
import { ModalDescription } from 'src/Modal/styles'
import { HUBSPOT } from 'src/Utils/hubspot/hubspot.utils'
import { MessageType } from 'src/components/Reusable/Message/Message.constants'
import { Message } from 'src/components/Reusable/Message/Message'

// TODO [AP-7701]: Update KB article link
export const PolicyResponsibilityDescription = (): JSX.Element => (
  <ModalDescription>
    Read more about determining policy responsibility in our{' '}
    <PageAnchor
      href={HUBSPOT.POLICY_RESPONSIBILITY}
      target="_blank"
      rel="noreferrer"
    >
      Knowledge Base.
    </PageAnchor>
  </ModalDescription>
)

export const PolicyResponsibilityControlsSection = ({
  updateControls,
  setUpdateControls,
}: {
  updateControls: boolean
  setUpdateControls: React.Dispatch<React.SetStateAction<boolean>>
}): JSX.Element => (
  <>
    <Message
      messageType={MessageType.INFO}
      messageText="Marking a policy not applicable means that the controls in scope for the policy should also be marked not applicable. If you have controls that are not applicable, make sure to update them, as well. NOTE: The status of these controls will also be updated to 'Not Applicable'."
    />
    <CheckBoxInput
      id="update-policy-controls"
      label="Update responsibility for in-scope controls"
      checked={updateControls}
      onChange={() => {
        setUpdateControls((prev) => !prev)
      }}
    />
  </>
)
